import React from 'react';
import { StepProps } from '../../types/form';
import { FormField } from '../ui/FormField';
export function OtherStep({
  formData,
  updateFormData
}: StepProps) {
  return <div className="space-y-6" data-id="element-170">
      <div data-id="element-171">
        <h2 className="text-lg font-semibold text-foreground" data-id="element-172">Other Requirements</h2>
        <p className="text-sm text-muted-foreground" data-id="element-173">
          Anything else the onboarding team should know about this group.
        </p>
      </div>

      <FormField id="otherNotes" label="Additional Notes" hint="Partner details, special restrictions, timeline, or anything not covered above" data-id="element-174">
        <textarea value={formData.otherNotes} onChange={e => updateFormData({
        otherNotes: e.target.value
      })} className="w-full px-3 py-2 bg-background border border-input rounded-md text-sm min-h-[150px] resize-y" placeholder="Enter any other requirements here..." data-id="element-175" />
      </FormField>
    </div>;
}